import React, { FC } from 'react'
import { useField, useFormikContext } from 'formik'

import { Select, SelectOption } from './Select'

export const SelectField: FC<{
  name: string
  label: string
  options: SelectOption[]
  size?: 'sm' | 'lg'
  disabled?: boolean
  onChangeCustom?: void
  customValue?: string | number
}> = ({ name, label, options, size, disabled, onChangeCustom, customValue, ...props }) => {
  const { isSubmitting } = useFormikContext()
  const [{ value, onChange, ...field }, { error, touched }, { setValue, setTouched }] =
    useField<string | number>(name)

  return (
    <Select
      id={name}
      value={ customValue ? customValue : value}
      onChange={(value: string | number) => {
        onChangeCustom
        setValue(value)
        setTouched(true)
      }}
      label={label}
      disabled={disabled !== undefined ? disabled : isSubmitting}
      invalid={!!error && !!touched}
      innerProps={field}
      error={error}
      all={false}
      size={size}
      options={options}
      {...props}
    />
  )
}
